module.exports = __webpack_public_path__ + "img/title_sp.8a044fbc.svg";